import { useAPI } from '../../../clients/quipli-service/quipli-service-client';
import { StripeAccount, StripeAccountStatus } from '../../../clients/quipli-service/payment-config/payment-config';
import { useContext, useEffect, useState } from 'react';
import { Typography } from '../../../components/typography/typography';
import { DataTable, DataTableColumn, DataTableRow } from '../../../components/table/data-table';
import { Button } from '../../../components/form/button';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';
import { TenantContext } from '../../../context/tenant-context';
import { usePaymentConfigApiV1 } from '../../../clients/quipli-service/payment-config/payment-config-api-v1';

export const StripeAccountPage = () => {
  const { getCountry } = useAPI();
  const { getStripeAccount, getStripeAuthUrl } = usePaymentConfigApiV1();
  const { contextPath } = useContext(TenantContext);
  const [stripeUserInfo, setStripeUserInfo] = useState<StripeAccount | undefined>(undefined);
  const [data, setData] = useState<DataTableRow[]>([]);
  const [columns, setColumns] = useState<DataTableColumn[]>([
    { key: 'businessName', label: 'Business Name' },
    { key: 'businessEmail', label: 'Business Email' },
    { key: 'accountType', label: 'Account Type' },
    { key: 'createdAt', label: 'Created At' },
    { key: 'accountStatus', label: 'Account Status' },
    { key: 'updatedAt', label: 'Last Updated' },
  ]);
  const [country, setCountry] = useState<string>('');
  const navigate = useNavigate();

  useEffect(() => {
    Promise.all([getCountry(), getStripeAccount()]).then(([country, stripeAccount]) => {
      setCountry(country.code);
      if (stripeAccount) {
        const createdAt = stripeAccount.createdAt;
        const updatedAt = stripeAccount.updatedAt;
        const onboardingLabel = stripeAccount.accountStatus == 0 ? 'Complete Signup' : 'Edit Information';
        setStripeUserInfo(stripeAccount);
        setData([
          {
            fields: {
              businessName: stripeAccount.businessName,
              businessEmail: stripeAccount.businessEmail,
              accountType: stripeAccount.accountType,
              createdAt: DateTime.fromISO(createdAt.toString()).toFormat('LLL-dd-yyyy h:mm a'),
              accountStatus: StripeAccountStatus[stripeAccount.accountStatus],
              updatedAt: DateTime.fromISO(updatedAt.toString()).toFormat('LLL-dd-yyyy h:mm a'),
              actions: <Button onClick={() => signupStep(stripeAccount)}>{onboardingLabel}</Button>,
            },
            mobileHeader: <Typography type={'text-lg'}>Stripe Account</Typography>,
          },
        ]);
        setColumns([...columns, { key: 'actions', label: 'Actions' }]);
      }
    });
  }, []);

  async function signupStep(userInfo: StripeAccount) {
    if (userInfo.accountType === 'custom' && country == 'US') {
      navigate(`${contextPath}manager/quipli-pay/customConnectOnboarding/${userInfo.stripeAccountId}`);
    } else {
      const authUrl = await getStripeAuthUrl(userInfo.stripeAccountId);
      window.location.href = authUrl.url;
    }
  }

  return (
    <>
      <div>
        <div className={'section-head'}>
          <Typography type={'display-md'}>Manage - Stripe Account</Typography>
        </div>
        <div className="flex items-center gap-2">
          {(!stripeUserInfo || stripeUserInfo.accountType != 'custom') && (
            <Button
              onClick={() => {
                navigate(`${contextPath}manager/quipli-pay/setup`);
              }}
            >
              Add New Account
            </Button>
          )}
        </div>
      </div>
      {stripeUserInfo && <DataTable data={data} columnNames={columns} showAlwaysDesktop={true} />}
    </>
  );
};
